import { ChatWidget } from 'services/chatWidgets'
import actions from './actions'

export interface WidgetsState {
  /** v2 widgets only — what the list screen renders. */
  chatWidgetsList: ChatWidget[]
  /** Every widget including v1; the create call sends these ids back as `ids`. */
  chatWidgetsCombinedList: ChatWidget[]
  /** Base URL derived from the widget extension's adminURL; false until resolved. */
  chatWidgetAppUrl: string | false
  /** The widget the sub-routes act on. `[]` when none is selected — the legacy empty marker. */
  chatWidgetActive: ChatWidget | unknown[]
  areWidgetsLoading: boolean
}

const initialState: WidgetsState = {
  chatWidgetsList: [],
  chatWidgetsCombinedList: [],
  chatWidgetAppUrl: false,
  chatWidgetActive: [],
  areWidgetsLoading: true,
}

interface SetStateAction {
  type: typeof actions.SET_STATE
  payload: Partial<WidgetsState>
}

export default function widgetsReducer(
  state: WidgetsState = initialState,
  action: SetStateAction,
): WidgetsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
